module.exports = __webpack_public_path__ + "static/media/07-0402.599edd51.png";